/**
 * HTTP layer for a site group's weather configuration. The weather-source
 * settings that drive weather-aware scheduling.
 *
 * Contains:
 * - fetchSiteGroupWeatherConfigurationBySiteGroupId: read a site group's weather config
 * - patchSiteGroupWeatherConfiguration: write a site group's weather config
 */
// SiteGroup API

import apiClient from '@sophocles/http-common';

const SITE_GROUP_WEATHER_CONFIG_ENDPOINT = '/sitegroupweatherconfigurations';

export const fetchSiteGroupWeatherConfigurationBySiteGroupId = siteGroupId =>
  apiClient.get(`${SITE_GROUP_WEATHER_CONFIG_ENDPOINT}/?site_group=${siteGroupId}`).then(res => res.data);

export const patchSiteGroupWeatherConfiguration = (id, data) =>
  apiClient.patch(`${SITE_GROUP_WEATHER_CONFIG_ENDPOINT}/${id}`, data).then(res => res.data);
